import { createModel } from "hox";
import { getToken, getProdBaseRequestUrl } from "@/utils/constants";


export const invoiceModel = createModel(function () {

    const imageUrl = (url: string) => {
        return getProdBaseRequestUrl() + "/zzw-fsrv/fetch/" + url + "?Authorization=" + getToken();
    }

    return {
        imageUrl
    }
});
